module.exports = __webpack_public_path__ + "static/post-it-grey-f0650d0621ffb402cc7ce90130498a5c.png";